fragment CartFragment on Cart {

    total

    items {
        uuid

        product_id

        cartItemProductVariations {
            productVariation {

                size_name
                size_code

                flash_id
                flash_type

                color {
                    id
                    code
                    name
                    hex_codes
                }

            }
        }

        cartItemPrints {

            notes

            printAssignment {

                printTechnique {
                    code
                    type
                }

                location
            }

            printCost {
                key
                color
            }
        }

        cartItemAttachments {

            attachmentVariation {
                number
                name
            }

        }

        product {
            item_no
            type
            name
            slug
            featured_media {
                url
            }
        }

        calculated
    }

}